import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { FontSizes, FontWeights, Text, TextElements, units } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

import MeetIcon from '../../college/Meet';
import meetCalmMessages from '../messages/meetCalmMessages';

const MeetContainer = styled.div`
	margin: ${units(8.75)} 0;
`;

const MeetTitle = styled(Text).attrs({
	el: TextElements.H2,
	size: FontSizes['2xl'],
	weight: FontWeights.Light,
})`
	line-height: 61px;
	margin-bottom: ${units(4)};
	text-align: center;
`;

const MeetCalm = () => {
	const { formatMessage } = useIntl();
	return (
		<MeetContainer>
			<MeetTitle>{formatMessage(meetCalmMessages.title)}</MeetTitle>
			<GridWrapper columns={4}>
				<MeetIcon
					icon="circle"
					title="Meditate"
					subtitle="Learn the life-changing skill of meditation"
					backgroundColor="gradientBrightBlue"
					elementToScrollTo="college"
				/>
				<MeetIcon
					icon="moon"
					title="Sleep"
					subtitle="Get more restful sleep and wake up feeling refreshed"
					backgroundColor="gradientCalmBrand"
					elementToScrollTo="sleep"
				/>
				<MeetIcon
					icon="human"
					title="Body"
					subtitle="Video lessons on mindful movement and gentle stretching"
					backgroundColor="gradientCalmPurple"
					elementToScrollTo="college"
				/>
				<MeetIcon
					icon="music"
					title="Music"
					subtitle="Exclusive music to help you focus, relax, and sleep"
					backgroundColor="gradientPink"
					elementToScrollTo="college"
				/>
			</GridWrapper>
		</MeetContainer>
	);
};

export default MeetCalm;
